// Generated from api/openapi/operations.yaml by make docs. Do not edit.
import { z } from "zod";

export const scopeRequestSchema = z.object({
  "id": z.string().uuid(),
  "kind": z.enum(["scope_exclusion", "exception"]),
  "compensating_control": z.string().default(""),
  "requested_expires_at": z.string().default(""),
  "lapses_at": z.string().datetime({ offset: true }),
  "catalog_id": z.string().uuid(),
  "framework_id": z.string(),
  "framework_version": z.string(),
  "control_id": z.string(),
  "control_title": z.string(),
  "rationale": z.string(),
  "requested_by_email": z.string(),
  "requested_by_scope": z.enum(["tenant", "tenant_grant", "platform"]).optional(),
  "requested_at": z.string().datetime({ offset: true }),
  "reviewer_email": z.string(),
  "status": z.enum(["pending", "approved", "rejected", "withdrawn", "lapsed"]),
  "decided_at": z.string().datetime({ offset: true }).optional(),
  "decided_by_email": z.string().optional(),
  "decided_by_scope": z.enum(["tenant", "tenant_grant", "platform"]).optional(),
  "decision_note": z.string().optional()
});

export const scopeRequestListSchema = z.object({
  "data": z.array(scopeRequestSchema)
});
